<template>
  <div cols="12" lg="6" md="6" sm="12" :align="mLoc">
    <v-app-bar color="#FFFFFF" elevation="0" style="height: 80px; padding-top: 20px;">
      <v-spacer></v-spacer>

      <template>
        <v-col class="mr-4">
          <v-row justify="end">
            <h4 v-if="eng_name == '  '" style="color: #222222;">
              {{ this.th_name }}
            </h4>
            <h4 v-else style="color: #222222;">
              {{ this.eng_name }}
            </h4>
          </v-row>
          <v-row justify="end" style="margin-top: 10px; color: #0A7EA5;">
            <h4>
              {{ this.department_name }}
            </h4>
          </v-row>
        </v-col>
      </template>
      <template>
        <v-menu bottom min-width="200px" rounded offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon x-large v-on="on">
              <v-avatar size="300">
                <v-icon dark style="color: #808080 ; font-size: 50px;" v-if="image == ''">
                  mdi-account-circle
                </v-icon>
                <v-img v-else :lazy-src="image_profile" max-height="45px" max-width="45px" :src="image_profile"></v-img>
                <v-icon dark small left style="
                      color: #0A7EA5; 
                      font-size: 20px; 
                      margin-left: -10px;
                      margin-top: 25px;
                      background-color: #D8DADF;
                      width: 15px;
                      height: 15px;
                      display: flex; /* ใช้ flex เพื่อจัดไอคอนให้อยู่ตรงกลาง */
                      align-items: center;
                      justify-content: center;
                    ">
                  mdi mdi-chevron-down
                </v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content class="justify-start">
              <div class="mx-auto text-start">
                <v-divider class="mt-2"></v-divider>
                <v-btn depressed text block @click="resetPassword">
                  <v-icon small>mdi-account-settings-outline</v-icon>
                  My Profile
                </v-btn>
                <v-divider></v-divider>
                <v-btn depressed text block @click="onClickLogOff">
                  <v-icon small>mdi-export</v-icon>
                  logout
                </v-btn>
                <v-divider></v-divider>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
      </template>
    </v-app-bar>

    <v-speed-dial v-if="true" v-model="fab" bottom right fixed direction="top" transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn v-model="fab" color="#0A7EA5" dark fab outlined small @click="openChat">
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-chat
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>
  </div>
</template>

<script>
import { server, imageUrl } from "@/services/constants";
import api from "@/services/api";
export default {
  name: "Header",
  data() {
    return {
      mLoc: "",
      mycompany: [],
      th_name: "",
      eng_name: "",
      department_name: "",
      image: "",
      image_profile: "",
      user_text_profile: "",
      fab: false, // Add this line to control the FAB
    };
  },
  async mounted() {
    await this.getMyCompany();
    await this.loadEmpdata();
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
    title() {
      return process.env.VUE_APP_TITLE;
    },
    getENV() {
      return process.env.NODE_ENV;
    },
  },
  methods: {
    async loadEmpdata() {
      const res_emp = await api.getAccountByidMenu(
        localStorage.getItem(server.USER_ID)
      );
      // console.log(`loadEmpdata data: `, JSON.stringify(res_emp.data));

      this.th_name = res_emp.data[0].name;
      this.eng_name = res_emp.data[0].eng_name;
      this.department_name = res_emp.data[0].department_name;
      this.image = res_emp.data[0].image;

      if (this.image != "" && this.image != null) {
        this.image_profile =
          imageUrl +
          "/" +
          // localStorage.getItem(server.USER_ID) +
          // "/" +
          this.image;
        localStorage.setItem(server.USER_IMAGE_URL, this.image_profile);
      } else {
        // 💡 1. ป้องกันกรณีชื่อ eng_name ส่งมาเป็นค่าว่าง หรือไม่มีค่า
        if (this.eng_name && this.eng_name.trim() !== "") {

          const nameParts = this.eng_name.trim().split(/\s+/); // ตัดคำด้วยช่องว่าง (รองรับการเคาะช่องว่างหลายที)
          const firstLetter = nameParts[0] ? nameParts[0].substring(0, 1) : "";

          // เช็คว่ามีนามสกุล หรือคำด้านหลังไหม (ไม่ว่าจะอยู่อินเด็กซ์ที่ 1 หรือ 2)
          // ถ้ามีให้เอาตัวแรกมาใช้ ถ้าไม่มีให้ใช้ค่าว่าง
          let lastLetter = "";
          if (nameParts.length > 1) {
            // ดึงคำสุดท้ายของอาร์เรย์มาทำอักษรย่อตัวหลัง (ปลอดภัยที่สุด ไม่ฟิกซ์อินเด็กซ์)
            lastLetter = nameParts[nameParts.length - 1].substring(0, 1);
          }

          this.user_text_profile = firstLetter + lastLetter;
        } else {
          // 💡 2. เคสที่ชื่ออังกฤษไม่มีจริง ๆ ให้ดึงจากชื่อไทย th_name มาแก้ขัดแทน หรือใส่ตัวย่อกลาง ๆ ไว้
          this.user_text_profile = this.th_name ? this.th_name.substring(0, 1) : "U";
        }

        localStorage.setItem(server.USER_IMAGE_URL, null);
      }
    },
    async getMyCompany() {
      const result = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID)
      );
      this.mycompany = result.data;
    },
    onClickLogOff() {
      this.$store.state.navMenu = false;
      this.$store.dispatch("doLogout");
    },
    resetPassword() {
      // alert("Reset Password");
      this.$router.push("/my-profile");
    },

    openChat() {
      const dTimeData = {
        dtime_token: localStorage.getItem("dtime_token"),
        dtime_user_id: localStorage.getItem("dtime_user_id"),
        dtime_username: localStorage.getItem("dtime_username"),
        dtime_email: localStorage.getItem("dtime_email"),
        dtime_fullname: localStorage.getItem("dtime_fullname"),
        dtime_role: localStorage.getItem("dtime_role"),
        dtime_company_id: localStorage.getItem("dtime_company_id"),
        dtime_department_id: localStorage.getItem("dtime_department_id"),
        dtime_position_id: localStorage.getItem("dtime_position_id"),
        dtime_user_image_url: localStorage.getItem("dtime_user_image_url"),
        dtime_login_url: window.location.origin, // เพื่อให้กลับมาหา D-Time ได้
      };

      // สร้าง URL parameters
      const params = new URLSearchParams();
      Object.entries(dTimeData).forEach(([key, value]) => {
        if (value) {
          params.set(key, value); // ไม่ต้อง encodeURIComponent เพราะ URLSearchParams จัดการให้แล้ว
        }
      });

      // เปิด Chat ใน tab ใหม่หรือ popup
      const chatUrl = `https://chat-dev.dcm.co.th?${params.toString()}`;
      // const chatUrl = `http://localhost:3000?${params.toString()}`;
      window.open(chatUrl, "chat", "width=1200,height=800");
    },

    openChat_V2() {
      const dTimeData = {
        dtime_token: localStorage.getItem("dtime_token"),
        dtime_user_id: localStorage.getItem("dtime_user_id"),
        dtime_username: localStorage.getItem("dtime_username"),
        dtime_email: localStorage.getItem("dtime_email"),
        dtime_fullname: localStorage.getItem("dtime_fullname"),
        dtime_role: localStorage.getItem("dtime_role"),
        dtime_company_id: localStorage.getItem("dtime_company_id"),
        dtime_department_id: localStorage.getItem("dtime_department_id"),
        dtime_position_id: localStorage.getItem("dtime_position_id"),
        dtime_user_image_url: localStorage.getItem("dtime_user_image_url"),
        dtime_login_url: window.location.origin, // เพื่อให้กลับมาหา D-Time ได้
      };

      // สร้าง URL parameters
      const params = new URLSearchParams();
      Object.entries(dTimeData).forEach(([key, value]) => {
        if (value) {
          params.set(key, encodeURIComponent(value));
        }
      });

      // เปิด Chat ใน tab ใหม่หรือ popup
      // const chatUrl = `https://chat-dev.dcm.co.th?${params.toString()}`; // Fixed the backticks
      const chatUrl = `http://localhost:3000?${params.toString()}`; // Fixed the backticks
      window.open(chatUrl, "chat", "width=1200,height=800");
    },
  },
};
</script>

<style scoped>
.v-speed-dial--bottom {
  bottom: 5px;
}
</style>
